import { SECTION_THEME_ENUM } from '@/_types/base'

const ORDER_THEME_ADULT_SURFACE = 'bg-[#DDD3FF]/30 border border-medante-purple-light/50'
const ORDER_THEME_CHILD_SURFACE =
	'bg-medante-yellow-light-secondary/50 border border-medante-yellow-light'
const ORDER_THEME_CARD_UNKNOWN = 'bg-white/95'

const ORDER_THEME_CALENDAR_ADULT_SHELL =
	'bg-medante-purple-dark/10 ring-1 ring-medante-purple-dark/20'
const ORDER_THEME_CALENDAR_CHILD_SHELL =
	'bg-medante-yellow-light-secondary/45 ring-1 ring-amber-950/18'

export type OrderThemeClasses = {
	/** Krok 1 obal, košík (krok 3) a ďalšie plochy so „zafarbením“ kategórie. */
	surface: string
	/** Karty výberu produktu (krok 2); pri neznámej téme neutrálna karta. */
	card: string
	/** Rozšírený týždenný kalendár v karte šablóny — dospelí vs. deti. */
	calendarExpandedShell: string
}

/**
 * Jednotné pozadia objednávkového flowu podľa `sectionTheme` z API (dospelí / deti).
 */
export function getOrderThemeClasses(sectionTheme: SECTION_THEME_ENUM | null): OrderThemeClasses {
	if (sectionTheme == null) {
		return {
			surface: ORDER_THEME_ADULT_SURFACE,
			card: ORDER_THEME_CARD_UNKNOWN,
			calendarExpandedShell: ORDER_THEME_CALENDAR_ADULT_SHELL
		}
	}
	switch (sectionTheme) {
		case SECTION_THEME_ENUM.ADULT:
			return {
				surface: ORDER_THEME_ADULT_SURFACE,
				card: ORDER_THEME_ADULT_SURFACE,
				calendarExpandedShell: ORDER_THEME_CALENDAR_ADULT_SHELL
			}
		case SECTION_THEME_ENUM.CHILD:
			return {
				surface: ORDER_THEME_CHILD_SURFACE,
				card: ORDER_THEME_CHILD_SURFACE,
				calendarExpandedShell: ORDER_THEME_CALENDAR_CHILD_SHELL
			}
		default:
			return {
				surface: ORDER_THEME_ADULT_SURFACE,
				card: ORDER_THEME_CARD_UNKNOWN,
				calendarExpandedShell: ORDER_THEME_CALENDAR_ADULT_SHELL
			}
	}
}
